import { render, staticRenderFns } from "./LimitsTable.vue?vue&type=template&id=1552e28b&"
import script from "./LimitsTable.vue?vue&type=script&lang=js&"
export * from "./LimitsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports